import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';

import { unitOptions } from './config';

export default function ReminderOffsetInput({ reminder, onChange }) {
  return (
    <div className="form-group">
      <label className="form-label">
        Set Reminder for
      </label>
      <div className="form-input-container d-flex align-items-center gap-2 w-50">
        <ManagedInput
          aria-label="reminderOffset"
          className="form-control"
          minValue={0}
          name="modifier"
          type="number"
          value={reminder.modifier}
          onChange={onChange}
        />
        <ManagedInput
          aria-label="reminderUnits"
          className="form-control"
          name="units"
          type="select"
          value={reminder.units}
          onChange={onChange}
        >
          <Options options={unitOptions} />
        </ManagedInput>
        <div>Before</div>
      </div>
    </div>
  );
}

ReminderOffsetInput.propTypes = {
  reminder: PropTypes.shape({
    modifier: PropTypes.number,
    units: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
